import jwt_decode from 'jwt-decode';
import { getJWT } from './jwt';

// Valid alert fields for DESMA queries
/*
100XXX --> AST
200XXX --> RGE
210XXX -> RGE1
220XXX -> RGE2
300XXX --> SPE
310XXX -> SPE1
320XXX -> SPE2
330XXX -> SPE3
340XXX -> SPE4
500XXX --> AMIR-D
510XXX -> AMIR-C
600XXX --> NAS
700XXX --> Visu
*/
const ALERT_FIELDS = [
  'Alert/000000', // Dummy alert for detecting when no alert is present -> all alerts are closed
  'Alert/100*',
  'Alert/200*',
  'Alert/210*',
  'Alert/220*',
  'Alert/300*',
  'Alert/310*',
  'Alert/320*',
  'Alert/330*',
  'Alert/340*',
  'Alert/500*',
  'Alert/510*',
  'Alert/600*',
  'Alert/700*',
];

export function createAlertFieldsQuery() {
  return ALERT_FIELDS.map((field) => ({
    exists: {
      field: field,
    },
  }));
}

export function getAlertFields() {
  return [...ALERT_FIELDS];
}

export function isDESMApremium(state_config) {
  if (isDESMA(state_config)) {
    const token = getJWT();
    if (token) {
      const decodedAccessToken = jwt_decode(token);
      if (decodedAccessToken && decodedAccessToken.desma && decodedAccessToken.desma.premium) {
        return decodedAccessToken.desma.premium;
      }
    }
    return false;
  }

  return true;
}

export function isDESMA(state_config) {
  if (state_config.data) {
    return state_config.data.is_desma;
  }
  return false;
}
